import './IconUser.css'

function IconUser({ name = 'N', identification }) {
	const first = name.substr(0, 1);
	name = first.toUpperCase();
	return (
		<div className={`iconUser ${identification ? 'identificationCommerce' : ''}`} >
			{identification ? <span>{identification}</span> : <span>{name}</span>}
		</div>
	);
}

export default IconUser;
